import React from "react";
import { Link } from "react-router-dom";

const datasets = [
  {
    id: 1,
    title: "US Census Data",
    description:
      "Explore detailed demographics, social, and cultural metadata for every zip code in the U.S.",
    url: "https://app.snowflake.com/marketplace/listing/GZTSZ1PHJ02/openmetadata-net-us-census-demographic-economic-and-social-characteristics-by-zip-code?search=open%20metadata",
    highlights: [
      "Population demographics",
      "Income levels",
      "Education statistics",
      "Cultural diversity indexes",
    ],
  },
  {
    id: 2,
    title: "Consumer Price Index",
    description:
      "Analyze over a century of inflation data across 28 categories of goods and services.",
    url: "https://app.snowflake.com/marketplace/listing/GZTSZ1PHIYX/openmetadata-net-cpi-consumer-price-index-1913-present?originTab=provider&providerName=OpenMetaData.net&profileGlobalName=GZTSZ1PHIYL",
    highlights: [
      "Over 100 years of inflation data",
      "Categories like food, housing, and energy",
      "Monthly and annual CPI values",
      "Insights for cost-of-living adjustments",
    ],
  },

  {
    id: 3,
    title: "Cryptocurrency Tracking: Prices by Day",
    description:
      "Stay ahead of the crypto market with pricing data at your fingertips. Our dataset unlocks the power to analyze historical market trends.",
    url: "/datasets/crypto",
    highlights: [
      "Pricing metrics include Open, High, Low and Close",
      "Historical data for over 10 years",
      "Updated daily at end of day",
    ],
  },
  {
    id: 4,
    title: "Stock Tracking: US Stock Prices by Day",
    description:
      "Enhance your financial analysis with our cloud-hosted dataset covering over 5,000 U.S. stocks, providing extensive insights across major industries and sectors. Gain access to real-time data enriched with historical trends and key pricing metrics.",
    url: "/datasets/us-stock",
    highlights: [
      "Pricing metrics including Open, High, Low and Close",
      "Trading Volumes",
      "Historical data of up to 10 years",
      <>
        For a complete list of stocks see{" "}
        <a
          href="/stock-list"
          target="_blank"
          className="text-blue-500 underline hover:text-blue-700"
        >
          here
        </a>
      </>,
    ],
  },
  {
    id: 5,
    title: "Stock Tracking: Asian Stock Prices by Day",
    description:
      "Enhance your financial analysis with our cloud-hosted dataset covering over 5,000 U.S. stocks, providing extensive insights across major industries and sectors. Gain access to real-time data enriched with historical trends and key pricing metrics.",
    url: "/datasets/asian-stock",
    highlights: [
      "Pricing metrics including Open, High, Low and Close",
      "Trading Volumes",
      "Historical data of up to 10 years",
      <>
        For a complete list of stocks see{" "}
        <a
          href="/stock-list"
          target="_blank"
          className="text-blue-500 underline hover:text-blue-700"
        >
          here
        </a>
      </>,
    ],
  },
  {
    id: 6,
    title: "Forex Tracking: Currency Exchange Rates by Day",
    description:
      "Stay ahead of the forex market with pricing data at your fingertips. Our dataset unlocks the power to analyze historical market trends.",
    url: "/datasets/forex",
    highlights: [
      "Pricing metrics include Open, High, Low and Close",
      "Historical data for over 10 years",
      "Updated daily at end of day",
    ],
  },
];

const Datasets: React.FC = () => {
  return (
    <div className="bg-background min-h-screen">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-gradientFrom to-gradientTo text-white py-20 text-center px-6">
        <h1 className="text-5xl font-serif mb-4">Our Exclusive Datasets</h1>
        <p className="text-lg font-sans max-w-2xl mx-auto">
          Empower your organization with data-driven insights curated by
          experts.
        </p>
      </div>

      {/* Dataset Cards Section */}
      <div className="container mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {datasets.map((dataset) => (
          <div
            key={dataset.id}
            className="relative bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transform hover:scale-105 transition-all duration-300 flex flex-col h-full"
          >
            {/* Accent Line */}
            <div className="absolute inset-x-0 top-0 h-2 bg-gradient-to-r from-secondary to-accent"></div>

            <div className="p-6 flex flex-col flex-grow">
              <h2 className="text-2xl font-serif text-primary mb-4">
                {dataset.title}
              </h2>
              <p className="text-primary/70 font-sans mb-6">
                {dataset.description}
              </p>
              <ul className="text-sm font-sans text-primary/50 space-y-2 mb-6">
                {dataset.highlights.map((highlight, index) => (
                  <li key={index}>• {highlight}</li>
                ))}
              </ul>
              {/* <a href={dataset.url} target="_blank" rel="noopener noreferrer">
                <button className="block w-full text-center bg-primary text-white py-2 rounded-md hover:bg-primary/80 transition">
                  Learn More
                </button>
              </a> */}
              {/* Conditional Link or External URL */}
              <div className="mt-auto">
                {dataset.url.startsWith("/") ? (
                  <Link to={dataset.url}>
                    <button className="block w-full text-center bg-primary text-white py-2 rounded-md hover:bg-primary/80 transition ">
                      Learn More
                    </button>
                  </Link>
                ) : (
                  <a
                    href={dataset.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="block w-full text-center bg-primary text-white py-2 rounded-md hover:bg-primary/80 transition ">
                      Learn More
                    </button>
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Datasets;
